/* eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import API from './utils/api_v5'
import LoaderFull from 'loader-full'
import { Button as FoundationsButton, Icon as FoundationsIcon, Typography as FoundationsTypography } from 'foundations-library/components'
import { updateUser } from './actions/users'

import { withStyles } from '@material-ui/styles'
import RenderEmptyState from 'empty-states'

import MeetingsImage from './utils/images/meetings-image.jpg'
import { ThemeContext } from 'providers'

const styles = theme => ({
    infoItemsWrapper: {
        textAlign: 'center',
        fontSize: 20,
        lineHeight: 1.3,
        letterSpacing: -0.05,
        '& .value': {
            fontWeight: 'bold'
        },
        '&.small': {
            fontSize: 18
        }
    },
    infoItem: {
        '&:not(:first-child)': {
            marginTop: 20
        }
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)'
    },
    title: {
        fontSize: 14
    },
    pos: {
        marginBottom: 12
    },
    linkStyle: {
        color: theme.palette.primary.main
    },
    wrapper: {
        position: 'relative',
        overflow: 'auto',
        height: '100%',
        padding: '1rem',
        boxSizing: 'border-box',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        '-ms-overflow-style': 'none'
    },
    mainContent: {
        paddingTop: 40,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        boxSizing: 'border-box',
        '&.small': {
            padding: '35px 0 0'
        }
    },
    meetButton: {
        position: 'relative',
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'NTR, Montserrat, Helvetica, arial, sans-serif !important',
        lineHeight: 0.75,
        letterSpacing: -1.5,
        padding: '20px 0',
        width: 350,
        borderRadius: 60,
        marginBottom: 30,
        '&.small': {
            fontSize: 40,
            width: '80%',
            padding: '22px 0',
            marginBottom: 20
        }
    },
    arrowIcon: {
        width: '0.9em',
        height: '0.9em',
        fontSize: 'unset',
        position: 'absolute',
        right: 30
    },
    copyDetailsButton: {
        width: 180,
        height: 50,
        margin: '30px 0',
        cursor: 'pointer',
        '&.small': {
            margin: '20px 0'
        }
    },
    goToDashboardButton: {
        padding: '17px 30px',
        fontSize: 26,
        lineHeight: 1.12,
        letterSpacing: -0.37,
        borderRadius: 60,
        borderWidth: 3,
        boxShadow: 'none',
        fontWeight: 'normal',
        '& svg': {
            width: 26,
            height: 30,
            marginLeft: 20
        },
        '&.small': {
            fontSize: 20,
            padding: '14px 20px'
        }
    },
    copiedMessage: {
        width: 89,
        height: 49,
        borderRadius: 5,
        boxShadow: '2px 2px 5px 0 rgba(0, 0, 0, 0.2)',
        background: '#88969e',
        position: 'absolute',
        left: 50,
        bottom: 40,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        fontWeight: 600,
        lineHeight: 1.36,
        userSelect: 'none'
    },
    welcomeScreenWrapper: {
        display: 'flex',
        height: '100%'
    },
    imageSection: {
        background: '#9ea8b1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-around',
        width: 321
    },
    meetingsComputerImageWrapper: {
        width: '100%',
        '& img': {
            width: '100%'
        }
    },
    meetingsLogoImageWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        '& span': {
            color: '#F2F5F6',
            fontWeight: 'bold',
            fontSize: 25,
            marginTop: 15
        }
    },
    infoSection: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '& div': {
            maxWidth: 483,
            padding: '0 75px'
        },
        '& .main-text': {
            fontSize: 14,
            lineHeight: 1.43,
            '&:last-child': {
                marginTop: 15
            }
        },
        '& .more-info-link': {
            display: 'block',
            marginTop: 15,
            fontSize: 14,
            lineHeight: 1.43,
            letterSpacing: -0.05,
            color: theme.palette.primary.main,
            fontWeight: 'bold'
        },
        '& .ask-text': {
            display: 'block',
            marginTop: 15,
            '& a': {
                color: theme.palette.primary.main,
                fontWeight: 'bold'
            }
        }
    },

    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 20,
        alignSelf: 'stretch',
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        '& .content-item-container': {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 20,
            alignSelf: 'stretch',
            width: '100%',
            minWidth: 0,
            '& .content-item': {
                width: '100%',
                minWidth: 0,
                display: 'flex',
                padding: 10,
                alignItems: 'center',
                gap: 10,
                flex: '1 1 0',
                boxSizing: 'border-box',
                borderRadius: 10,
                border: '1px solid #D9D8D8',
                '& .icon-container': {
                    display: 'flex',
                    width: 56,
                    height: 56,
                    padding: 6,
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 10,
                    flexShrink: 0,
                    aspectRatio: '1/1',
                    borderRadius: 10,
                    background: 'rgba(217, 216, 216, 0.35)',
                },
                '& .content-item-text': {
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    overflowWrap: 'anywhere',
                    gap: 4,
                    flex: '1 1 0',
                    '& .content-item-text-copy-container': {
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 6,
                        minWidth: 0,
                        width: '100%',
                        '& > :last-child': {
                            minWidth: 0,
                            overflowWrap: 'anywhere'
                        }
                    }
                },
                '& > button': {
                    flexShrink: 0
                }
            }
        },
        '@media (max-width: 600px)': {
            gap: 12,
            '& .content-item-container': {
                flexDirection: 'column',
                gap: 12,
                '& .content-item': {
                    flex: 'none'
                }
            },
            '& .content-item-container:first-child .content-item': {
                flexWrap: 'wrap',
                '& > button': {
                    width: '100%',
                }
            }
        }
    },

    welcomeData: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxSizing: 'border-box',
    color: '#252525',
    textAlign: 'center',

    '& .welcome-description': {
        margin: 0,
        fontSize: 18,
        lineHeight: 1.45,
        '& a': {
            textDecoration: 'underline',
            color: '#252525',
        }
    },

    '& .welcome-features': {
        display: 'inline-block',
        margin: '28px auto 12px',
        paddingLeft: 22,
        fontSize: 18,
        lineHeight: 1.5,
        textAlign: 'left'
    },

    '& .welcome-access': {
        margin: '12px 0 38px',
        fontSize: 18,
        lineHeight: 1.45
    },

    '& .welcome-pricing': {
        color: theme.palette.primary.main,
        fontSize: 18,
        lineHeight: 1.4,
        fontWeight: 600,
        textDecoration: 'none',

        '&:hover': {
            textDecoration: 'underline'
        }
    },

    '@media (max-width: 600px)': {
        padding: '0 16px',

        '& .welcome-description, & .welcome-features, & .welcome-access, & .welcome-pricing': {
            fontSize: 16
        },

        '& .welcome-features': {
            marginTop: 20,
            paddingLeft: 20
        },

        '& .welcome-access': {
            marginBottom: 28
        }
    }
}
})

const mapStateToProps = state => ({
    user: state.user
})

const mapDispatchToProps = dispatch => ({
    updateUser: user => dispatch(updateUser(user))
})

class App extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            user: null,
            meetingLinkCopied: false,
            inviteCopied: false
        }
        console.log(props)
    }

    static contextType = ThemeContext

    componentDidMount = async () => {
        console.log('meeting mounted', this.props.extension.extension_id)
        const response = await API.get_user(this.props.extension.extension_id)
        this.props.updateUser(response)
        this.props.onLoaded()
    }

     onCopyDetailsClick = async () => {
        let text = 'You have been invited to a video meeting.\n\n'
        text += `You can join the meeting by visiting ${this.props.user.meeting_url}.`
        text += `${this.props.user.primary_dialin_number
            ? `\n\nOr you may dial in to ${this.props.user.primary_dialin_number.international_format} and use access code ${this.props.user.access_code}.`
            : ''}`
        this.setState({ inviteCopied: true })

        try {
            await navigator.clipboard.writeText(text)
            console.log('Async: Copying to clipboard was successful!')
        } catch (err) {
            console.error('Async: Could not copy text: ', err)
        } finally {
            window.setTimeout(() => this.setState({ inviteCopied: false }), 2000)
        }
    }

    onCopyMeetingLinkClick = async () => {
        let text = this.props.user.meeting_url
        this.setState({ meetingLinkCopied: true })

        try {
            await navigator.clipboard.writeText(text)
            console.log('Async: Copying to clipboard was successful!')
        } catch (err) {
            console.error('Async: Could not copy text: ', err)
        } finally {
            window.setTimeout(() => this.setState({ meetingLinkCopied: false }), 2000)
        }
    }

    getBaseUrl = fullUrl => {
        const pathArray = fullUrl.split('/')
        const protocol = pathArray[0]
        const host = pathArray[2]
        const url = protocol + '//' + host
        return url
    }

    toggleCopyDetailsHover = copyDetailsHover => this.setState({ copyDetailsHover })
    toggleGoToDashboardHover = goToDashboardHover => this.setState({ goToDashboardHover })

    renderWelcomeScreen = () => {
        const { classes } = this.props
        const theme = this.context

        let content = null
        if (window.V5PHONECOM && window.V5PHONECOM.user_id) {
            content = <div>
                <p>Video meetings allows you to conduct video meetings online where you can see and hear each other, share your computer screen, and much more.</p>
                <p>Video comes included with your Phone.com plan, but you need to ask your Phone.com administrator to assign you a meeting host using our admin tool.</p>
            </div>
        } else {
            content = 
            <section className="video-meetings-info">
                <p className="video-meetings-description">
                    Host HD video meetings and share your screen, right from{' '}
                    <a href="https://www.phone.com" target="_blank" rel="noreferrer">
                    Phone.com
                    </a>
                    . No downloads, no hassle.
                </p>

                <ul className="video-meetings-features">
                    <li>Meet for as long as you need, with no participant limit friction</li>
                    <li>Share your screen and documents in real time</li>
                    <li>Join from your phone or computer — nothing to install</li>
                    <li>HIPAA-compliant plans available</li>
                </ul>

                <p className="video-meetings-access">
                    Don't have access yet? Ask your admin to add Video Meetings to your
                    account.
                </p>

                <a href="/pricing" className="video-meetings-pricing">
                    Find pricing details and more information here
                </a>
            </section>
        }
        return (
            <div className={classes.welcomeScreenWrapper}>
                <div className={classes.imageSection}>
                    <div style={{ height: 81 }}></div>
                    <div className={classes.meetingsComputerImageWrapper}>
                        <img src={MeetingsImage}/>
                    </div>
                    <div className={classes.meetingsLogoImageWrapper}>
                        <img src={theme.icons.ghostIcon} />
                        <span>VIDEO MEETINGS</span>
                    </div>
                </div>
                <div className={classes.infoSection}>
                    {content}
                </div>
            </div>
        )
    }

    meetNowURL = () => {
        if (window.V5PHONECOM.user_id) {
            const pathArray = this.props.user.meeting_url.split('/')
            const base_url = pathArray[0] + '//' + pathArray[2]
            const iotum_auth = '/auth/openid_connect?landing_url='
            const landing_url = '%2F' + pathArray[3] + '%2F' + pathArray[4] + '%2F' + pathArray[5]
            const url = base_url + iotum_auth + landing_url
            return url
        }
        return this.props.user.meeting_url
    }

    meetDashboardUrl = () => {
        let url = this.getBaseUrl(this.props.user.meeting_url)
        if (window.V5PHONECOM?.user_id) {
            url += '/auth/openid_connect'
        }
        return url
    }

    renderContentItem = (icon, heading, info, button) => {
        return (
            <div className={'content-item'}>
                <div className={'icon-container'}>
                    <FoundationsIcon size='medium' color='neutral-700' name={icon} />
                </div>
                <div className={'content-item-text'}>
                    <FoundationsTypography variant='subtitle1' color='neutral-700'>{heading}</FoundationsTypography>
                    {typeof info === 'string' ? <FoundationsTypography variant='h7' color='neutral-900'>{info}</FoundationsTypography> : info}
                </div>
                {button}
            </div>
        )
    }

    meetingData = () =>{
        const { classes, user } = this.props

        const meetingUrlDivContainer = (
            <div className={'content-item-text-copy-container'}>
                <FoundationsIcon size='medium' color='primary-500' name='copy' onClick={this.onCopyMeetingLinkClick} style={{ cursor: 'pointer', flexShrink: 0 }} />
                <FoundationsTypography variant='h8' color='primary-500' style={{ minWidth: 0, overflowWrap: 'anywhere' }}>
                    {user.meeting_url}
                </FoundationsTypography>
            </div>
        )

        const meetNowButton = (
            <FoundationsButton variant='contained' color='primary' size='large' icon='go' onClick = {() => window.open(this.meetNowURL(), '_blank')}>Meet now</FoundationsButton>
        )

        const dialInNumber = user.primary_dialin_number ? user.primary_dialin_number.international_format : 'no dial in numbers found'
        const accessCode = user.access_code
        const moderatorPin = user.moderator_pin
        const email = user.email
        
            return {
                title:"",
                content :(
                    <div className={classes.contentContainer}>
                        <div className={'content-item-container'}>
                            {this.renderContentItem('start-meeting', 'Meeting URL', meetingUrlDivContainer, meetNowButton)}
                        </div>
                        <div className={'content-item-container'}>
                            {this.renderContentItem('call-incoming', 'Dial in Number', dialInNumber.toString())}
                            {this.renderContentItem('start-meeting', 'Access Code', accessCode.toString())}
                        </div>
                        <div className={'content-item-container'}>
                            {this.renderContentItem('lock', 'Moderator Pin', moderatorPin.toString())}
                            {this.renderContentItem('email', 'Connected Email', email.toString())}
                        </div>
                    </div>
                ),
                buttons:([
                    <FoundationsButton variant='contained' color='neutral' size='large' icon='open-in-new-alt' onClick={() => window.open(this.meetDashboardUrl(), '_blank')}>Meeting dashboard</FoundationsButton>,
                    <FoundationsButton variant='outlined' color='primary' size='large' style={{ gap: 4 }} onClick={this.onCopyDetailsClick}>
                        <FoundationsIcon size='medium' color='primary' name='copy' />
                        Copy details
                    </FoundationsButton>
                ])
        }
    }

    welcomeData = () => {
        const { classes } = this.props
        const pricingUrl = "https://www.phone.com/pricing"
        return {
            title:{text:"Bring your team face-to-face — from anywhere"},
            content : (
                <div className={`${classes.contentContainer} ${classes.welcomeData}`}>
                    <p className="welcome-description">
                        Host HD video meetings and share your screen, right from <a href={pricingUrl}>Phone.com</a>.
                        No downloads, no hassle.
                    </p>

                    <ul className="welcome-features">
                        <li>Meet for as long as you need, with no participant limit friction</li>
                        <li>Share your screen and documents in real time</li>
                        <li>Join from your phone or computer — nothing to install</li>
                        <li>HIPAA-compliant plans available</li>
                    </ul>

                    <p className="welcome-access">
                        Don't have access yet? Ask your admin to add Video Meetings to your
                        account.
                    </p>

                    <a href={pricingUrl} className="welcome-pricing">
                        Find pricing details and more information here
                    </a>
                </div>
            ),
            buttons:([])
        }
    }

    renderEmptyState = () => {
        const { user } = this.props

        const data = user.errorMessage ? this.welcomeData() : this.meetingData()
        return (
            <RenderEmptyState 
                svg={{ name: 'meeting' }} 
                title={data.title}
                customContent={data.content}
                buttons={data.buttons}
                rootStyles={{ maxWidth: '800px', width: '100%', boxSizing: 'border-box' }}
            />
        )
    }

    render () {
        const { classes } = this.props
        const isSmall = this.props.screenViewType.isMobileView

        return (
            <div className={classes.wrapper}>
                {(this.props.user)
                    ? <div className={`${classes.mainContent} ${isSmall ? 'small' : ''}`}>
                        {this.renderEmptyState()}
                    </div>
                    : <LoaderFull styles={{ loaderFull: { left: '50%' } }} size='big'/>
                }
                {this.state.inviteCopied || this.state.meetingLinkCopied ? <div className={classes.copiedMessage}>Copied!</div> : null}
            </div>
        )
    }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(App))
